(ns practitest.frontend.xbot.views
  (:require
    [goog.string :as gstring]
    [cljs.pprint :as pprint]
    [clojure.string :as string]
    [practitest.frontend.routing.backend-routes :as broutes]
    [re-frame.core :as re-frame]
    [cljsjs.moment]
    [reagent.core :as r]
    [reagent.dom.server :as rds]
    ["react-c3js" :default C3Chart]
    ["react-modal" :as ReactModal]
    [practitest.frontend.xbot.events :as events]
    [practitest.frontend.xbot.agents-view.views :as av-views]
    [practitest.frontend.common.ui :as ui]
    [practitest.frontend.xbot.subs :as subs]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.components.grid :as grid]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.overlay :as overlay]
    [practitest.frontend.forms3.entity-form.header :refer [breadcrumbs-view]]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.react-bootstrap :as react-bootstrap]
    [reagent.core :as reagent]
    ["react-bootstrap/Tabs" :as Tabs]
    ["react-bootstrap/Tab" :as Tab]))

(defn display-run-telemetry [telemetry]
  (let [timestamps (map #(js/Date.parse (:now %)) telemetry)
        loadavg    (map (comp :load1 :load) telemetry)
        memory     (map (comp :usedPercent :memory) telemetry)
        cpu        (map (comp first :cpu_percentage) telemetry)]
    [:div
     {:style {:display        :flex
              :flex-direction :row}}
     (when (seq (filter some? loadavg))
       [:div
        {:style {:flex 1}}
        (let [chart-params {:data       {:x       "timestamp"
                                         :columns [(cons "timestamp" timestamps)
                                                   (cons "LoadAvg" loadavg)]}
                            :axis       {:x {:type "timeseries"
                                             :tick {:format "%H:%M:%S"}}}
                            :transition {:duration 500}}]
          [:> C3Chart chart-params])])
     [:div
      {:style {:flex 1}}
      (let [chart-params {:data       {:x       "timestamp"
                                       :columns [(cons "timestamp" timestamps)
                                                 (cons "CPU" cpu)]}
                          :axis       {:x {:type "timeseries"
                                           :tick {:format "%H:%M:%S"}}
                                       :y {:min 0 :max 100 :padding 0}}
                          :transition {:duration 500}}]
        [:> C3Chart chart-params])]
     [:div
      {:style {:flex 1}}
      (let [chart-params {:data       {:x       "timestamp"
                                       :columns [(cons "timestamp" timestamps)
                                                 (cons "Memory" memory)]}
                          :axis       {:x {:type "timeseries"
                                           :tick {:format "%H:%M:%S"}}
                                       :y {:min 0 :max 100 :padding 0}}
                          :transition {:duration 500}}]
        [:> C3Chart chart-params])]]))

(defn radio-buttons-ui [label name value checked state]
  [:div.radio
   [:label
    [:input
     {:type           :radio
      :name           name
      :value          value
      :defaultChecked checked
      :onClick        (fn [e] (swap! state assoc-in [:popup :schedule-run-now] (.. e -target -value)))}]
    label]])

(defn move-to-queue-modal [state]
  (let [rad-btn-val (get-in @state [:popup :schedule-run-now])
        popup-state (:popup @state)]
    [:>
     ReactModal
     (ui/modal-settings state popup-state)
     (r/as-element
      [:div.x-text-in-modal
       [:h4 "Run TestSet now"]
       [:div.button-group
        (radio-buttons-ui "Run now and Keep scheduled" :schedule-run-now :keep true state)
        (radio-buttons-ui "Run now and Remove scheduled" :schedule-run-now :remove false state)
        [:div
         [:button.btn.btn-default.x-btn-in-modal.bolder
          {:on-click (fn [_]
                       (swap! state assoc-in [:popup :open?] false))}
          "Cancel"]
         [:button.btn.btn-default.x-btn-in-modal.blue-bg.bolder
          {:on-click (fn [_]
                       (re-frame/dispatch
                        [::events/run-now-item
                         {:url (:run-now-url popup-state)
                          :id  (:testset-id popup-state)}])
                       (if (= rad-btn-val "remove")
                         (re-frame/dispatch
                          [::events/delete-schedule-item
                           {:url            (:delete-url popup-state)
                            :job-project-id (:project-id popup-state)
                            :job-suite-id   (:testset-id popup-state)}]))
                       (swap! state assoc-in [:popup :open?] false))}
          "Run"]]]])]))

(defn remove-from-queue-modal [state]
  (let [popup-state (:popup @state)]
    [:>
     ReactModal
     (ui/modal-settings state popup-state)
     (r/as-element
      [:div.x-text-in-modal
       (if (= (:status popup-state) "RUNNING")
         [:h5.padding-bottom-10 "This will cancel the run"]
         [:h5.padding-bottom-10 "This will delete the pending run"])
       [:div.button-group
        [:div
         [:button.btn.btn-default.x-btn-in-modal
          {:on-click (fn [_]
                       (swap! state assoc-in [:popup :open?] false))}
          (if (= (:status popup-state) "RUNNING")
            "Back"
            "Cancel")]

         [:button.btn.btn-default.x-btn-in-modal.blue-bg
          {:on-click (fn [_]
                       (case (:status popup-state)
                         "PENDING" (re-frame/dispatch
                                    [::events/delete-queue-item
                                     {:url            (:delete-url popup-state)
                                      :job-client-id  (:job-client-id popup-state)
                                      :job-project-id (:job-project-id popup-state)
                                      :job-run-id     (:job-run-id popup-state)}])
                         "RUNNING" (re-frame/dispatch
                                    [::events/kill-running-item
                                     {:url            (:kill-url popup-state)
                                      :job-project-id (:job-project-id popup-state)
                                      :job-agent-id   (:job-agent-id popup-state)}]))
                       (swap! state assoc-in [:popup :open?] false))}
          (if (= (:status popup-state) "RUNNING")
            "OK"
            "Delete")]]]])]))

(defn remove-recurrence-modal [state]
  (let [rad-btn-val (get-in @state [:popup :schedule-run-now])
        popup-state (:popup @state)]
    [:>
     ReactModal
     (ui/modal-settings state popup-state)
     (r/as-element
      [:div.x-text-in-modal
       [:div.button-group
        (if (= (:recurrence popup-state) "No")
          [:h4
           {:style {:margin-bottom "20px"}}
           "Do you want to delete this scheduled run?"]
          [:<>
           [:h4 "Delete recurring xBot run"]
           (radio-buttons-ui "This run" :schedule-delete :skip-next-run true state)
           (radio-buttons-ui "This and future runs" :schedule-delete :delete-all false state)])
        [:div
         [:button.btn.btn-default.x-btn-in-modal.bolder
          {:on-click (fn [_]
                       (swap! state assoc-in [:popup :open?] false))}
          "Cancel"]

         [:button.btn.btn-default.x-btn-in-modal.blue-bg.bolder
          {:style    {:float "right"}
           :on-click (fn [_]
                       (case rad-btn-val
                         "skip-next-run"   (re-frame/dispatch
                                            [::events/skip-next-run-item
                                             {:url            (:skip-next-run-url popup-state)
                                              :job-project-id (:project-id popup-state)
                                              :job-suite-id   (:testset-id popup-state)
                                              :skip           true}])
                         "delete-all" (re-frame/dispatch
                                       [::events/delete-schedule-item
                                        {:url            (:delete-url popup-state)
                                         :job-project-id (:project-id popup-state)
                                         :job-suite-id   (:testset-id popup-state)}]))
                       (swap! state assoc-in [:popup :open?] false))}
          "Delete"]]]])]))

(defn convert-queue-data
  [data]
  (doall
    (for [row data]
      {:id           (get-in row [:run :id])
       :testset-name {:url   (get-in row [:testset :url])
                      :title (get-in row [:testset :name])}
       :instance     {:url   (get-in row [:instance :url])
                      :title (get-in row [:test :name])}
       :run          {:url   (get-in row [:run :url])
                      :title (get-in row [:run :name])}
       :machine_name (get row :machine_name)
       :client_id    (get row :client_id)
       :run_status   (get-in row [:run :status])
       ;; TODO: use users dictionary from init-app
       :run_by       {:id           (get-in row [:run :run_by_id])
                      :type         "user"
                      :name         (or (get-in row [:run :run_by]) "")
                      :is_certified (get-in row [:run :run_by_certified])
                      :avatar       (if-let [avatar-url (get-in row [:run :run_by_avatar])]
                                      {:type "image"
                                       :url  avatar-url}
                                      {:type "icon"})}

       :next_run_date (get-in row [:testset :next_run_date])
       :recurrence    (get-in row [:testset :recurrence])

       :scheduled_by {:id           (get-in row [:testset :scheduled_by_id])
                      :type         "user"
                      :name         (get-in row [:testset :scheduled_by])
                      :is_certified (get-in row [:testset :scheduled_by_certified])
                      :avatar       (if-let [avatar-url (get-in row [:testset :scheduled_by_avatar])]
                                      {:type "image"
                                       :url  avatar-url}
                                      {:type "icon"})}

       :original     row})))

(defn history-list-table []
  (let [data (:runs @(re-frame/subscribe [::subs/current-history]))]
    [grid/grid {:loading?   (re-frame/subscribe [::subs/remote? :refresh-history])
                :columns    (reagent/track
                              (fn []
                                [{:type        :url
                                  :field       :testset-name
                                  :autofilter? true
                                  :header      "TestSet"}

                                 {:type        :url
                                  :field       :instance
                                  :autofilter? true
                                  :header      "Instance"}

                                 {:type        :url
                                  :field       :run
                                  :autofilter? true
                                  :header      "Run Date"}

                                 {:type        :field
                                  :field       :machine_name
                                  :autofilter? true
                                  :header      "Machine Name"}

                                 {:type        :user
                                  :field       :run_by
                                  :autofilter? true
                                  :header      "Run by"}

                                 {:type        :run_status
                                  :field       :run_status
                                  :autofilter? true
                                  :header      "Run Status"}

                                 {:type        :custom
                                  :sortable?   false
                                  :autofilter? false
                                  :header-fn   (fn [column]
                                                 [:<>
                                                  "Re-Run"

                                                  [:button.btn.btn-sm.btn-primary.ms-3
                                                   {:on-click #(re-frame/dispatch [::events/refresh-history])
                                                    :title "Refresh Table"
                                                    :disabled @(re-frame/subscribe [::subs/remote? :refresh-history])}

                                                   [icons/arrow-clockwise]]])

                                  :cell-fn     (fn [column row]
                                                 (let [item (get row :original)]
                                                   [:button.btn.btn-sm.btn-outline-pt-secondary
                                                     {:on-click (fn [e]
                                                                  (.preventDefault e)
                                                                  (when (js/confirm "Are you sure?")
                                                                    (re-frame/dispatch
                                                                      [::events/run-now-item
                                                                       {:url (:run-now-url item)
                                                                        :id  (get-in item [:instance :id])}])))}
                                                     [:span.me-1
                                                      [icons/play-circle]]
                                                     "Run now"]))}]))
                :resizable? false
                :data       (reagent/track
                              ;; prepare data
                              #(convert-queue-data data))}]))

(defn schedule-list-table []
  (let [mtq-state (r/atom {:popup {:open? false}})
        rr-state  (r/atom {:popup {:open? false}})]
    (fn []
      (let [data @(re-frame/subscribe [::subs/current-schedule])]
        [:<>
         [move-to-queue-modal mtq-state]
         [remove-recurrence-modal rr-state]
         [grid/grid {:loading?     (re-frame/subscribe [::subs/remote? :refresh-schedule-queue])
                     :columns      (reagent/track
                                     (fn []
                                       [{:type        :url
                                         :field       :testset-name
                                         :autofilter? true
                                         :header      "TestSet"}

                                        {:type        :user
                                         :field       :scheduled_by
                                         :autofilter? true
                                         :header      "Scheduled by"}

                                        {:type   :field
                                         :field  :next_run_date
                                         :header "Next Run Date"}

                                        {:type   :field
                                         :field  :recurrence
                                         :header "Recurrent"}

                                        {:type      :custom
                                         :sortable? false
                                         :header-fn (fn [column]
                                                      [:<>
                                                       "Actions"
                                                       [overlay/overlay
                                                        {:placement "bottom"}

                                                        (fn [overlay-state]
                                                          [:i.clickable.ms-1.me-1
                                                           {:on-click (overlay/make-on-click-handler overlay-state)}
                                                           [icons/question-circle-fill]])

                                                        [react-bootstrap/tooltip
                                                         "Pressing the ‘x’ button will let you delete the test set from the schedule queue or to skip the next run of that test set"]]

                                                       [:button.btn.btn-sm.btn-primary.ms-3
                                                        {:title "Refresh Table"
                                                         :on-click #(re-frame/dispatch [::events/refresh-schedule-queue])
                                                         :disabled @(re-frame/subscribe [::subs/remote? :refresh-schedule-queue])}
                                                         [icons/arrow-clockwise]]])
                                         :cell-fn   (fn [column row]
                                                      (let [item (:original row)]
                                                        [:<>
                                                         [:button.btn.btn-sm.btn-outline-pt-secondary
                                                          {:on-click (fn [_]
                                                                       (swap! mtq-state update :popup
                                                                              (fn [popup-state]
                                                                                (assoc popup-state
                                                                                  :open? true
                                                                                  :testset-id (get-in item [:testset :id])
                                                                                  :project-id (get-in item [:project :id])
                                                                                  :testset-name (get-in item [:testset :name])
                                                                                  :run-now-url (:run-now-url item)
                                                                                  :delete-url (:delete-url item)
                                                                                  :schedule-run-now "keep"))))}
                                                          [:span.me-1
                                                           [icons/play-circle]]
                                                          "Move to queue now"]

                                                         [:button.btn.btn-sm.btn-outline-pt-secondary
                                                          {:on-click (fn [_]
                                                                       (swap! rr-state update :popup
                                                                              (fn [popup-state]
                                                                                (assoc popup-state
                                                                                  :open? true
                                                                                  :testset-id (get-in item [:testset :id])
                                                                                  :project-id (get-in item [:project :id])
                                                                                  :testset-name (get-in item [:testset :name])
                                                                                  :run-now-url (:run-now-url item)
                                                                                  :delete-url (:delete-url item)
                                                                                  :recurrence (get-in item [:testset :recurrence])
                                                                                  :skip-next-run-url (:skip-next-run-url item)
                                                                                  :schedule-run-now "skip-next-run"))))
                                                           :disabled (nil? (:delete-url item))}
                                                          [:span.me
                                                           [icons/x-circle]]]]))}
                                        ]))
                     :resizable?   false
                     :data         (reagent/track
                                     ;; prepare data
                                     #(convert-queue-data data))}]]))))



(defn queue-list-table []
  (let [state (r/atom {:popup {:open? false}})]
    (fn []
      (let [data (:jobs @(re-frame/subscribe [::subs/current-queue]))]
        [:<>
         [remove-from-queue-modal state]
         [grid/grid {:loading?     (re-frame/subscribe [::subs/remote? :refresh-history])
                     :row-props-fn (fn [tableprops row]
                                     {:class (when (= (:id row) @(re-frame/subscribe [::subs/current-run-id]))
                                               "bg-info")})
                     :columns      (reagent/track
                                     (fn []
                                       [{:type        :url
                                         :field       :testset-name
                                         :autofilter? true
                                         :header      "TestSet"}

                                        {:type        :url
                                         :field       :instance
                                         :autofilter? true
                                         :header      "Instance"}

                                        {:type        :url
                                         :field       :run
                                         :autofilter? true
                                         :header      "Run created at"}

                                        {:type        :field
                                         :field       :client_id
                                         :autofilter? true
                                         :header      "Client Type"}

                                        {:type        :user
                                         :field       :run_by
                                         :autofilter? true
                                         :header      "Run by"}

                                        {:type        :run_status
                                         :field       :run_status
                                         :autofilter? true
                                         :header      "Run Status"}

                                        {:type      :custom
                                         :sortable? false
                                         :header-fn (fn [column]
                                                      [:<>
                                                       "Cancel/Remove"

                                                       [overlay/overlay
                                                        {:placement "bottom"}

                                                        (fn [overlay-state]
                                                          [:i.clickable.ms-1.me-1
                                                           {:on-click (overlay/make-on-click-handler overlay-state)}
                                                           [icons/question-circle-fill]])

                                                        [react-bootstrap/tooltip
                                                         "Pressing the ‘x’ button will cancel and remove the test run from the queue"]]

                                                       [:button.btn.btn-sm.btn-primary.ms-3
                                                        {:title "Refresh Table"
                                                         :on-click #(re-frame/dispatch [::events/refresh-queue])
                                                         :disabled @(re-frame/subscribe [::subs/remote? :refresh-queue])}
                                                        [icons/arrow-clockwise]]]
                                                      )
                                         :cell-fn   (fn [column row]
                                                      (let [item (:original row)]
                                                        [:button.btn.btn-md.btn-remove-bg
                                                         {:on-click (fn [_]
                                                                      (swap! state update :popup
                                                                             (fn [popup-state]
                                                                               (assoc popup-state
                                                                                 :open? true
                                                                                 :job-client-id (:client_id item)
                                                                                 :job-project-id (get-in item [:project :id])
                                                                                 :job-run-id (get-in item [:run :id])
                                                                                 :job-agent-id (get-in item [:run :agent_id])
                                                                                 :delete-url (:delete-url item)
                                                                                 :kill-url (:kill-url item)
                                                                                 :status (get-in item [:run :status])))))
                                                          :disabled (and (nil? (:delete-url item)) (nil? (:kill-url item)))}
                                                         [icons/x-circle]]))}
                                        ]))
                     :resizable?   false
                     :data         (reagent/track
                                     ;; prepare data
                                     #(convert-queue-data data))}]]))))

(defn other-projects-jobs-ui [jobs-num]
  [:div.other-projects-jobs
   [:span "There are " jobs-num " queued items from other projects"]])

(defn display-run []
  (let [current-run @(re-frame/subscribe [::subs/current-run])]
    [:div.well
     [display-run-telemetry @(re-frame/subscribe [::subs/current-telemetry])]
     [queue-list-table]
     (if (get-in current-run [:telemetry :id])
       [av-views/display-agent (:telemetry current-run)]
       (when (= "PENDING" #(re-frame/subscribe [::subs/run-status]))
         [queue-list-table]))]))

(defn queue-status []
  (let [other-jobs-count (:other_projects_jobs @(re-frame/subscribe [::subs/current-queue]))]
    [:<>
     (when (pos? other-jobs-count)
       [other-projects-jobs-ui other-jobs-count])
     [queue-list-table]]))

(defn schedule-status []
  [schedule-list-table])

(defn history-status []
  [history-list-table])

(defn queue-management []
  (let [current-tab @(re-frame/subscribe [::subs/current-qm-tab])]
    [:div.col
     [:div.card
      [:div.card-body
       [:> Tabs {:transition true
                 :active-key (or (name current-tab) "queue")
                 :on-select (fn [tab-key]
                              (re-frame/dispatch [::events/set-qm-tab (keyword tab-key)]))
                 :class "mb-3"}
        [:> Tab {:event-key "queue"
                 :title "Current & Queue"}
         [queue-status]]
        [:> Tab {:event-key "schedule"
                 :title "Scheduled"}
         [schedule-status]]
        [:> Tab {:event-key "history"
                 :title "History"}
         [history-status]]]]]]))

(defn main-panel []
  [:div
   [breadcrumbs-view {:breadcrumbs [{:href  (broutes/get-url-view "suites#index")
                                     :label (get-translation "navigation.project-menu.testsets" "Test sets & Runs")}]
                      :section "Automation"}]
   (case @(re-frame/subscribe [::subs/view])
     "admin"            [av-views/account-agents-view]
     "run"              [display-run]
     "queue-management" [queue-management])
   (when ^boolean js/goog.DEBUG
     [ui/debug-info])])

;;(ReactModal/setAppElement "#app")
